require("!!/home/entyo/github/entyo/koekatamarine/node_modules/script-loader/addScript.js")(require("!!/home/entyo/github/entyo/koekatamarine/node_modules/raw-loader/index.js!/home/entyo/github/entyo/koekatamarine/node_modules/three/examples/js/controls/OrbitControls.js"))


//////////////////
// WEBPACK FOOTER
// /home/entyo/github/entyo/koekatamarine/~/script-loader!/home/entyo/github/entyo/koekatamarine/~/three/examples/js/controls/OrbitControls.js
// module id = ../../../../script-loader/index.js!../../../../three/examples/js/controls/OrbitControls.js
// module chunks = 2